<template>
  <base-form-field
    v-model="confirmPayoffRequest"
    :schema="schema"
    :options="options"
    :disabled="submittingData"
    @update:model-value="confirmPayoff"
  />
</template>
<script setup lang="ts">
import { ref, reactive } from "vue";
import type { FieldSchema, Option } from "@/models/form";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import type { StipulationInputRequest } from "@/models/api";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import { $api } from "@/services/api";

interface Props {
  applicant: Applicant;
  stip: Stipulation;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (e: "success", updatedStip: Stipulation): void;
}>();

const submittingData = ref<boolean>(false);
const confirmPayoffRequest = ref<string | undefined>(undefined);

const schema = reactive<FieldSchema>({
  type: "radio",
  hideLabel: true,
} as FieldSchema);

const options = reactive<Array<Option>>([
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
]);

async function confirmPayoff() {
  submittingData.value = true;

  if (confirmPayoffRequest.value !== undefined) {
    const request = {
      applicationStipulationId: props.stip?.id,
      applicationId: props?.stip?.applicationId,
      genericInput: {
        input: confirmPayoffRequest.value,
      },
    } as StipulationInputRequest;

    const response = await $api.applications.addStipInput(props?.stip?.applicationId, request);

    if (response?.id && response?.id > 0) {
      // updates stip status to pending
      let updatedStip = props.stip;
      updatedStip.stipulationStatusId = response.stipulationStatusId;
      updatedStip.stipulationStatusName = response.stipulationStatusName;

      emit("success", updatedStip);

      submittingData.value = false;
    } else {
      submittingData.value = false;
    }
  } else {
    submittingData.value = false;
  }
}
</script>
